export const PAYMENT_METHOD_TYPES = {
  CARD: 'card',
  EPS: 'eps',
  BANK: 'bank',
  CRYPTO: 'crypto',
  ACARD: 'acard_me',
  ACARD_GLOBAL: 'acard_global',
};
